export function validateSantander(agencyNumber, accountNumber, givenCheckDigit) {
  // This script cannot validate santander accounts with checkDigit 0
  if (givenCheckDigit == 0) {
      return true;
  }
  if (agencyNumber.length < 4) {
    agencyNumber = agencyNumber.padStart(4, '0');
  }
  if (accountNumber.length < 8) {
    accountNumber = accountNumber.padStart(8, '0');
  }
  return calculate(agencyNumber, accountNumber) == givenCheckDigit;
}

function calculate(agencia, conta){
    let texto = agencia + '00' + conta;
    texto = texto.split('');    
    const multplicadores = ['9','7','3','1','0','0','9','7','1','3','1','9','7','3'];
    let total = 0;

    for(let i = 0;i < texto.length; i++){
        multplicadores[i] *= texto[i]

        if( multplicadores[i] > 9){
            multplicadores[i] =  parseInt(multplicadores[i].toString().substring(1), 10)
        }

        total += multplicadores[i]
    }

    if( total > 9){
        total =  parseInt(total.toString().substring(1), 10)
    }

    total = 10 - total    

    return total
}